
import Vue, { PropType } from 'vue'
import Opz2Icon from './Opz2Icon.vue'
import Opz2Table, { Column } from './Opz2Table.vue'
import {
    DASH,
    FUNCTION_STATUS,
    Report,
    Row,
    STATUS_LABEL,
    adminLabel,
    clientLabel,
    has,
    shortDate,
    staffLabel,
    yesNo,
    yclientsUrl,
} from './model'

/**
 * Строки детализации — same_spec_details / cross_sail_table функции как есть.
 * Мастер ОПЗ-записи: opz_staff_id и opz_staff_specialization; «впервые»:
 * opz_is_firstly. Нет поля — «—».
 */
export default Vue.extend({
    name: 'Opz2DetailTable',
    components: { Opz2Icon, Opz2Table },
    props: {
        report: { type: Object as PropType<Report>, required: true },
        items: { type: Array as PropType<Row[]>, required: true },
        kind: { type: String as PropType<'opz' | 'cross'>, required: true },
        emptyLabel: { type: String, default: 'Нет записей за период' },
    },
    data: () => ({ STATUS_LABEL, DASH }),
    computed: {
        columns(): Column[] {
            const cross = this.kind === 'cross'
            return [
                { label: 'Клиент', key: 'client', width: 196, cls: '' },
                { label: cross ? 'Направление и мастер' : 'Мастер', key: 'masterText', width: 212 },
                { label: 'Создана', key: 'visit_date', width: 106 },
                { label: 'Дата визита', key: 'opz_visit_date', width: 115 },
                { label: 'Статус', key: 'status', width: 118 },
                { label: 'Впервые', key: 'firstText', width: 99 },
                { label: 'Администратор', key: 'adminName', width: 167 },
                { label: 'YCLIENTS', width: 72 },
            ].map(col => ({
                ...col,
                cellCls:
                    col.key === 'client'
                        ? 'client-cell'
                        : col.key === 'masterText'
                        ? 'route-cell'
                        : col.key
                        ? ''
                        : 'row-actions',
            }))
        },
        rows(): Row[] {
            const cross = this.kind === 'cross'
            return this.items.map(item => {
                const master = has(item.opz_staff_id) ? staffLabel(this.report, item.opz_staff_id) : DASH
                return {
                    ...item,
                    client: clientLabel(this.report, item.client_id),
                    masterText: cross
                        ? `${item.staff_specialization || DASH} → ${item.opz_staff_specialization || DASH}`
                        : master,
                    // под мастером ОПЗ — его специализация, под направлением кросс-продажи — мастер
                    serviceText: cross ? master : item.opz_staff_specialization || DASH,
                    status: has(item.opz_status)
                        ? FUNCTION_STATUS[item.opz_status as keyof typeof FUNCTION_STATUS]
                        : null,
                    firstText: yesNo(item.opz_is_firstly),
                    adminName: adminLabel(this.report, item.opz_creating_user_id),
                    yclientsUrl: yclientsUrl(this.report.clients[item.client_id]?.hrefInfo),
                }
            })
        },
    },
    methods: {
        dateText(day: unknown) {
            return has(day) ? shortDate(String(day)) : DASH
        },
    },
})
